/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  currentSearch selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectCurrentSearchView = (state: State) => state.currentSearchView

export const selectShowNightlyPrice = compose(
  (state) => state.showNightlyPrice,
  selectCurrentSearchView
)

export const selectToggleValue = compose(
  (currentSearchView) => currentSearchView.toggleValue,
  selectCurrentSearchView
)
